import telegram from './telegram.svg'

const telegramAccountImages = { telegram }

export default telegramAccountImages
